import { c as _c } from "react/compiler-runtime";
import { JSX, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Box, Button, Link, Stack, Typography } from '@mui/material';
import { baseColors } from '@/layout/theme';
import BottomBanners from '@/components/BottomBanners/BottomBanners';
import { useTranslation } from 'react-i18next';
import AlertDialog from '@/components/ui/AlertDialog';
export function Copyright() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Typography variant="body1" color="textSecondary" align="center"><Link underline="hover" href="https://nemlia.com/" target="blank" sx={{
        fontSize: 15,
        color: "neutral.dark"
      }}>Powered by Nemlia Sp/f</Link></Typography>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export function Version() {
  const $ = _c(1);
  const versionDetails = `${process.env.NEXT_PUBLIC_VERSION}/${process.env.NEXT_PUBLIC_BUILD_DATE}` + `/${process.env.NEXT_PUBLIC_GITHUB_SHA}/${process.env.NEXT_PUBLIC_GITHUB_RUN_NUMBER}`;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Typography variant="body2" color="textSecondary" align="center"><a href="#" title={versionDetails}>.</a></Typography>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export default function Login() {
  const $ = _c(19);
  const {
    loginWithRedirect,
    isAuthenticated
  } = useAuth0();
  const {
    t
  } = useTranslation();
  const [forceLogout, setForceLogout] = useState(_temp);
  if (isAuthenticated) {
    return null;
  }
  let t0;
  if ($[0] !== forceLogout || $[1] !== t) {
    t0 = forceLogout ? <AlertDialog open={true} title={t("general.forced_logout_message")} type="warning" setOpen={() => {
      localStorage.setItem("isForceLogout", "false");
      setForceLogout(false);
    }} onConfirm={() => {
      localStorage.setItem("isForceLogout", "false");
      setForceLogout(false);
    }} /> : null;
    $[0] = forceLogout;
    $[1] = t;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      height: "100vh",
      position: "relative",
      p: 5
    };
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      height: "90%",
      justifyContent: "center",
      alignItems: "center"
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      fontSize: 74
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Typography component="h1" variant="h2" sx={t3}>Welcome to <span style={{
        color: baseColors.primary,
        fontWeight: "500"
      }}>Stýra</span></Typography>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      borderRadius: 999,
      fontSize: 20,
      width: 350,
      py: 1.5
    };
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== loginWithRedirect) {
    t6 = <Stack spacing={7} sx={t2}>{t4}<Button sx={t5} size="large" variant="contained" color="primary" onClick={() => loginWithRedirect()}>Log In</Button></Stack>;
    $[8] = loginWithRedirect;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      width: "100%",
      justifyItems: "center",
      alignItems: "center",
      position: "absolute",
      bottom: 20,
      left: 0
    };
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Box><Copyright /></Box>;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t10;
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Stack sx={t7}>{t8}<Box><Version /></Box></Stack>;
    t10 = <BottomBanners />;
    $[12] = t10;
    $[13] = t9;
  } else {
    t10 = $[12];
    t9 = $[13];
  }
  let t11;
  if ($[14] !== t6) {
    t11 = <Box sx={t1}>{t6}{t9}{t10}</Box>;
    $[14] = t6;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t0 || $[17] !== t11) {
    t12 = <>{t0}{t11}</>;
    $[16] = t0;
    $[17] = t11;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  return t12;
}
function _temp() {
  return localStorage.getItem("isForceLogout") === "true";
}